// extracted by mini-css-extract-plugin
module.exports = {"container":"novel_container__f7yta","tagsContainer":"novel_tagsContainer__eefNS","tag":"novel_tag__1A2Yn","activeTag":"novel_activeTag__ky53e"};